import React, { useContext } from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { useQuery } from '@apollo/react-hooks'
import Redirect from '#src/components/Redirect'
import { FullPageLoader } from '@deal/components'
import { IdentityContext } from '#src/containers/Identity'
import { DepartmentContext } from '#src/context/department'
import { LatestLeadQuery, LatestLeadDocument, DepartmentType } from '#src/generated/graphql'
import LoggedOutHome from './LoggedOutHome'

const Home: React.SFC<RouteComponentProps<{}>> = ({ location }) => {
  const departmentContext = useContext(DepartmentContext)
  const identityContext = useContext(IdentityContext)

  /**
   * If logged in, query for their latest lead and derive
   * their department from that. If that lead doesn't have a department
   * or is our internal department, just show them the homepage.
   */
  if (identityContext && identityContext.myself) {
    const latestLeadQuery = useQuery<LatestLeadQuery>(LatestLeadDocument)

    if (latestLeadQuery.loading) {
      return <FullPageLoader />
    }

    const departmentFromLead =
      latestLeadQuery.data &&
      latestLeadQuery.data.me &&
      latestLeadQuery.data.me.user.mostRecentLead &&
      latestLeadQuery.data.me.user.mostRecentLead.department

    const departmentFromContext = departmentContext && departmentContext.department

    const department = departmentFromContext || departmentFromLead

    if (department && department.type !== DepartmentType.CURATED_INTERNAL) {
      return <Redirect to={{ pathname: `/d/${department.slug}`, search: location.search }} />
    }
  }

  return <LoggedOutHome />
}

export default withRouter(Home)
